import '@/assets/css/default.scss';
import '@mdi/font/css/materialdesignicons.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee, faUser } from '@fortawesome/free-solid-svg-icons'; // Import specific icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createApp } from 'vue';
import App from './App.vue';
import plugins from './plugins';
import router from './router';
import { pinia } from './store';

// Add icons to the library
library.add(faUser, faCoffee);
// const app = createApp(App);
// app.component('font-awesome-icon', FontAwesomeIcon);
createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(pinia)
  .use(router)
  .use(plugins)
  .mount('#app');
